<template>
    <div id="wroks">
        <Loading :loadingHide="loadingHide"></Loading>
        <Header></Header>
        <div class="container works">
            <div class="works-header">
                <ul class="worksNavList">
                    <li :class="typeId? '' : 'active'" @click="(e) => toggleType(e.target)">全部</li>
                    <li
                        :class="typeId == item.id? 'active' : ''"
                        v-for="(item, index) in worksTypeList"
                        :key="index"
                        @click="(e) => toggleType(e.target, item.id)">{{item.name}}</li>
                </ul>
                <div>
                    <el-input placeholder="请输入内容" v-model="search" @change="goSearch" class="input-with-select">
                        <el-button slot="append" @click="goSearch" icon="el-icon-search"></el-button>
                    </el-input>
                </div>
            </div>
            <div class="sort-bar">
                <el-radio-group v-model="tabPosition" style="margin-bottom: 30px;">
                    <el-radio-button label="topDate">精选</el-radio-button>
                    <el-radio-button label="visNum">最热</el-radio-button>
                    <el-radio-button label="createDate">最新</el-radio-button>
                </el-radio-group>
            </div>
            <div class="row"  v-if="worksCardList.length > 0">
                <div 
                    class="col-sm-6 col-md-3"
                    v-for="(item, index) in worksCardList"
                    :key="index"
                >
                    <div class="team_member">
                        <div class="entry" @click="$router.push({path: `workcontent/${item.id}`});">
                            <img class="img-responsive" :src="item.cover" alt="">
                        </div>
                        <div class="lawyer">
                            <h3>{{ item.name }}</h3>
                            <div class="lawyer-details">
                                <div class="user-panel border-top">
                                    <img @click="goUserHome(item.authorId)" :src="item.authorAvatar?item.authorAvatar :''" class="user-headimg" />
                                    <span @click="goUserHome(item.authorId)">{{item.authorName? item.authorName : ''}}</span>
                                </div>
                                <div class="user-panel">
                                    <ul class="user-eyes">
                                        <li class="likes"> <svg-icon class="like" icon-class="zan"/>{{item.likeNum}}</li>
                                        <li class="eyes"><i class="el-icon-view"></i>{{item.visNum}}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <span v-else class="defaultWorks">
                <img src="@/assets/icon/notdata.png" alt="">
                暂时没有作品
            </span>
        </div>
        <el-pagination
          v-if="totalPages > 1"
          background
          :page-size="pageSize"
          :current-page="pageNumber"
          @current-change="handleCurrentChange"
          :page-count="totalPages"
          layout="total, prev, pager, next"
          :total="totalElements">
        </el-pagination>
        <Foot></Foot>
    </div>
</template>
<script>
import Loading from '@/components/loading';
import Header from '@/components/header';
import Foot from '@/components/foot';
import communityApi from "@/request/api/community";

export default {
    computed: {
        institutionId() {
            return this.$store.state.institutionId;
        }
    },
    components: {
        Loading,
        Header,
        Foot
    },
    data() {
        return {
            worksTypeId: '', //当前类型导航Id
            worksTypeList: [], //分来导航数据列表
            search: "", //搜索词
            searchDackups: "", //备份搜索词
            pageNumber: 1, //当前请求页
            worksCardList: [], //卡片列表
            totalPages: 0, //总页数
            totalElements: 0, //总条数
            typeId: '',
            pageSize: 8, //每页显示条数,
            tabPosition: "visNum",
            worksTypeState: false,
            worksListState: false,
            loadingHide: false
        }
    },
    watch: {
        worksTypeState() {
            if(this.worksTypeState && this.worksListState) {
                this.loadingHide = true;
            }
        },
        worksListState() {
            if(this.worksTypeState && this.worksListState) {
                this.loadingHide = true;
            }
        },
        tabPosition() {
            this.pageNumber = 1;
            this.getCardList();
        },
    },
    created() {
        $(document).scrollTop(0);
        if(this.$route.params.sort) {
            this.tabPosition = this.$route.params.sort;
        }
        this.getWorksTypeList();
        this.toggleType();
    },
    methods: {
        //获取类型列表
        getWorksTypeList() {
            communityApi.worksTypeList(res => {
                if(res.succeed) {
                    this.worksTypeList = res.data;
                }
                this.worksTypeState = true;
            })
        },
        //获取卡片列表
        getCardList() {
            let params = {
                name: this.search,
                worksTypeId: this.worksTypeId,
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
                sortDirection: 1,
                sortName: this.tabPosition,
                status: "已发布",
                institutionId: this.institutionId

            }
            communityApi.worksListByType(params, res => {
                if(res.succeed) {
                    this.worksCardList = res.data.content? res.data.content: [];
                    this.totalPages = res.data.totalPages? res.data.totalPages: 0;
                    this.totalElements = res.data.totalElements? res.data.totalElements: 0;
                }
                this.worksListState = true;
            })
        },
        //切换类型
        toggleType(target, id="") {
            // if(this.$route.params.typeId) {
            //     this.worksTypeId = this.$route.params.typeId;
            // }
            if(target) {
                $(target).addClass('active').siblings().removeClass('active');
                this.worksTypeId = id;
                this.pageNumber = 1;
                this.getCardList();
            } else {
                this.typeId = this.$route.params.typeId? this.$route.params.typeId : "";
                this.worksTypeId = this.$route.params.typeId? this.$route.params.typeId : "";
                this.getCardList();
            }
        },
        //切换排序
        toggleSort() {
            
        },
        //搜索
        goSearch() {
            if(this.search != this.searchDackups) {
                this.getCardList();
                this.searchDackups = this.search;
            }
        },
        //分页
        handleCurrentChange(val) {
            this.pageNumber = val;
            this.getCardList();
        },
        // goContentPage(id) {
        //     this.
        // },
        //查看卡片用户
        goUserHome(id) {
            this.$router.push({ name: "personhome", query: { id }});
        },
    },
}
</script>

<style lang="scss">
#wroks {
    .works {
        min-height: 700px;
    }
    .lawyer,
    .attorney-button {
        background-color: var(--theme-color);
    }
    // .el-icon-view {
    //     color: #fff;
    // }
    .lawyer .pf_button {
        cursor: pointer;
    }
    .lawyer .pf_button:hover {
        color: var(--theme-color);
    }
    .el-radio-button__orig-radio:checked+.el-radio-button__inner {
        background-color: var(--theme-activeColor);
        border-color: var(--theme-activeColor);
        box-shadow: -1px 0 0 0 var(--theme-activeColor);
    }
    .input-with-select button,
    .el-radio-group span:checked{
        color: #fff;
        background-color: var(--theme-color);
    }
    .el-input.is-active .el-input__inner, .el-input__inner:focus {
        border-color: var(--theme-color);
    }
    .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: var(--theme-color);
        color: var(--theme-fontColor) !important;
    }
    .el-pagination.is-background .el-pager li:not(.disabled):hover {
        color: var(--theme-color);
    }
    .user-panel {
        overflow: hidden;
    }
    .user-panel li {
        position: relative;
        display: inline-block;
        font-size: 15px;
    }
    .user-eyes {
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        margin-bottom: 0;
    }
    .user-eyes li:nth-child(1) {
        margin-right: 10px;
    }
    .user-eyes i {
        margin-right: 5px;
    }
    // .user-eyes .like {
    //     padding: 9px;
    //     margin-right: 5px;
    //     background-image: url("../../assets/zan.png");
    //     background-repeat: no-repeat;
    //     background-position: center center;
    //     background-size: contain;
    // }
    .user-panel.border-top {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: flex-start;
        align-items: center;
    }
    .user-headimg {
        width: 25px;
        height: 25px;
        border-radius: 50%;
        margin-right: 4px;
        cursor: pointer;
    }
    .user-panel.border-top span {
        font-size: 13px;
        white-space: nowrap;
        text-overflow: ellipsis;
        cursor: pointer;
        overflow: hidden;
    }
    .el-pagination {
        display: flex;
        justify-content: center;
        margin: 50px 0;
    }
    .works-header {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: space-between;
        align-items: center;
        padding: 30px 0;
    }
    .worksNavList li {
        display: inline-block;
        font-size: 18px;
        color: #333;
        font-weight: bold;
        padding: 6px 18px;
        margin-right: 15px;
        border-bottom: 2px solid rgba(255, 255, 255, 0);
        transition: all 0.45s ease-in-out;
        cursor: pointer;
    }
    .worksNavList li.active {
        color: var(--theme-activeColor);
        border-bottom-color: var(--theme-activeColor);
        transform:scaleX(1)
    }
    .works-search {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: flex-start;
        align-items: center;
    }
    .defaultWorks  {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 70px;
        color: #8a8a8a;
        font-size: 15px;
        min-height: 550px;
    }
    .defaultWorks  img {
        width: 80px;
    }
    @media (max-width: 880px) { 
        .works-header {
            flex-direction: column;
        }
        .works-header li {
            width: auto;
        }
    }
}

</style>


// WEBPACK FOOTER //
// src/views/works/works.vue